import { SearchEbookSaleAnalytics } from './SearchEbookSaleAnalytics'
import { withSearchEbookSaleAnalytics } from './withSearchEbookSaleAnalytics'

const ConnectedSearchEbookSaleAnalytics = withSearchEbookSaleAnalytics(
  SearchEbookSaleAnalytics
)

export { ConnectedSearchEbookSaleAnalytics as SearchEbookSaleAnalytics }
